import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const SanAntonioSpursLink = () => (
  <Link
    target="_blank"
    href="https://am.ticketmaster.com/spurs/"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    Account Manager
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect to your San Antonio Spurs account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for the games.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your San Antonio Spurs{" "}
        <SanAntonioSpursLink /> within 24 hours of redemption. Reach out to Live
        Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the San Antonio Spurs Holiday Pack work?",
    description:
      "The San Antonio Spurs Holiday Pack lets you pick three games from two tiers of games. Your purchase also comes with free parking in Lot 7 for each game and one Spurs Fiesta Bag per order!",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your San Antonio Spurs{" "}
        <SanAntonioSpursLink />.
      </>
    ),
  },
  {
    title: "How do I get my Spurs Fiesta Bag?",
    description:
      "Pickup in person at the Frost Bank Center SE VIP entrance between 9am-4pm on 12/19, 12/22, 12/23, 12/29. Or pickup at the following game dates: 1/3, 1/19, 1/25, 2/1.  Additional purchase confirmation will be emailed to you.",
  },
];

export const RegistrationTerms = () => (
  <>
    By checking this box you agree to receive notifications and offers from the
    San Antonio Spurs and to the{" "}
    <Link
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      target={"_blank"}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const CheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
